let cacheConfig: any[] = []
const cacheAsset = ""

//export let webBasePath = 'https://8.217.11.48:8443'
// export let webBasePath = 'https://114.132.96.101:38443' // 注意结尾不要 /
// export let webBasePath = 'https://daascveqarqwe-dev1.workol.cn' // 注意结尾不要 /

const configuredDefaultServerUrl = (
  window as typeof window & { defaultServerUrl?: string }
).defaultServerUrl
export const webBasePath =
  localStorage.getItem("serverUrl") ?? configuredDefaultServerUrl ?? "" // 注意结尾不要 /

export function getServerUrl(path: string): string {
  const base = (
    localStorage.getItem("serverUrl") ??
    configuredDefaultServerUrl ??
    ""
  ).replace(/\/$/, "")
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  return `${base}${normalizedPath}`
}

/**
 * 获取CDN地址的通用方法
 * @param {string} url - 请求的URL
 * @returns {Promise<any[]>} - 返回一个Promise，解析后得到CDN地址
 */
export async function getCdnUrl(): Promise<any[]> {
  if (cacheConfig.length == 0) {
    cacheConfig = [
      {
        url: "https://avatar-debug.workol.cn/keldaanCommunity/SpriteCollab/master/",
        name: "avatar.com-1"
      },
      {
        url: "https://avatar-debug2.workol.cn/keldaanCommunity/SpriteCollab/master/",
        name: "avatar.com-2"
      },
      {
        url: "https://ghfast.top/raw.githubusercontent.com/keldaanCommunity/SpriteCollab/master/",
        name: "ghfast.top"
      },
      {
        url: "https://gh-proxy.com/raw.githubusercontent.com/keldaanCommunity/SpriteCollab/master/",
        name: "gh-proxy.com"
      },
      {
        url: "https://bitbucket.org/dforel/spritecollab/raw/94825143be0cc329ee848ee7bc741feb123ae2bd/",
        name: "bitbucket.org"
      }
    ]
  }
  return cacheConfig
}

/**
 * 获取CDN地址的通用方法
 * @param {string} url - 请求的URL
 * @returns {Promise<string>} - 返回一个Promise，解析后得到CDN地址
 */
export async function getAssetUrl(): Promise<string> {
  return cacheAsset
}
